import Route from '@ember/routing/route';
import { set, get } from '@ember/object';
import { service } from '@ember/service';

export default Route.extend({
  navbarSettings: service(),

  model() {
    set(this, 'navbarSettings.title', 'Delete Fund Group');

    let fundGroupModel = this.modelFor('admin.fund-groups.fund-group');
    let fundGroup = get(fundGroupModel, 'fundGroup');
    return {
      record: fundGroup,
    };
  },
});
